module.exports = __webpack_public_path__ + "static/media/TwitterScoreShareIcon.cd4c7718.svg";